import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

const ReactModal = (props) => {
    const handleCloseModal = (event) => {
        event.preventDefault()
        props.handleCloseModal()
    }

    const Heading = (
        <div className='heading-block'>
            <h2 className='m-0'>{props.heading}</h2>
        </div>
    )

    return (
        <Modal
            isOpen={props.showModal}
            onRequestClose={event => handleCloseModal(event)}
            className={`reactModal ${props.heading ? 'has-heading' : ''}`}
            overlayClassName='reactModalOverlay'
            ariaHideApp={false}
        >
            {props.heading ? Heading : ''}
            <div className='inner'>
                {props.children}
            </div>
            <a href='#' className='close' onClick={event => handleCloseModal(event)}>
                <img src={`/images/${props.heading ? 'icon-close-white' : 'icon-close'}.svg`} alt='Close' />
            </a>
        </Modal>
    )
}

ReactModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    handleCloseModal: PropTypes.func.isRequired,
    heading: PropTypes.string
}

export default ReactModal



// WEBPACK FOOTER //
// ./resources/js/modules/ReactModal.js